// extracted by mini-css-extract-plugin
export default {"message":"state-message_message__HFIgb","default":"state-message_default__B6DZL","error":"state-message_error__m7TtO","success":"state-message_success__htevA"};